// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axios from 'axios';

// const API_URL = process.env.REACT_APP_API_URL;

// // Thunk for logging in
// export const loginUser = createAsyncThunk(
//   'auth/loginUser',
//   async ({ email, password }, { rejectWithValue }) => {
//     try {
//       const response = await axios.post(`${API_URL}/users/login`, { email, password });
//       return response.data; // { access_token, token_type, user, role }
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.detail || error.response?.data || 'Login failed');
//     }
//   }
// );

// // Thunk for fetching and restoring user session by token (on reload)
// export const fetchCurrentUser = createAsyncThunk(
//   'auth/fetchCurrentUser',
//   async (_, { rejectWithValue }) => {
//     try {
//       const token = sessionStorage.getItem('access_token');
//       if (!token) throw new Error("No token in sessionStorage");

//       const response = await axios.get(`${API_URL}/users/me`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       // response.data: { user, role }
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.detail || error.response?.data || "Failed to restore user");
//     }
//   }
// );

// const initialState = {
//   user: null,
//   token: sessionStorage.getItem('access_token') || null,
//   isLoggedIn: !!sessionStorage.getItem('access_token'),
//   loading: false,
//   error: null,
// };

// const authSlice = createSlice({
//   name: 'auth',
//   initialState,
//   reducers: {
//     logoutUser: (state) => {
//       state.user = null;
//       state.token = null;
//       state.isLoggedIn = false;
//       sessionStorage.removeItem('access_token');
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       // Login logic
//       .addCase(loginUser.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(loginUser.fulfilled, (state, action) => {
//         state.loading = false;
//         state.user = {
//           ...action.payload.user,
//           role: action.payload.role,
//         };
//         state.token = action.payload.access_token;
//         state.isLoggedIn = true;
//         sessionStorage.setItem('access_token', action.payload.access_token);
//       })
//       .addCase(loginUser.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload || 'Login failed';
//         state.isLoggedIn = false;
//       })
//       // Restore user from token (on reload)
//       .addCase(fetchCurrentUser.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchCurrentUser.fulfilled, (state, action) => {
//         state.loading = false;
//         state.user = {
//           ...action.payload.user,
//           role: action.payload.role,
//         };
//         state.isLoggedIn = true;
//       })
//       .addCase(fetchCurrentUser.rejected, (state, action) => {
//         state.loading = false;
//         state.user = null;
//         state.token = null;
//         state.isLoggedIn = false;
//         sessionStorage.removeItem('access_token');
//         state.error = action.payload || "Failed to restore user";
//       });
//   },
// });

// export const { logoutUser } = authSlice.actions;
// export default authSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// 🧩 Thunk for logging in
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/users/login`, {
        email,
        password,
      });

      // if backend accidentally returns HTML instead of JSON
      if (
        typeof response.data === "string" &&
        response.data.includes("<!DOCTYPE")
      ) {
        throw new Error("HTML error page received");
      }

      return response.data;
    } catch (error) {
      if (error.response) {
        const data = error.response.data;

        // ✅ Detect if the response body is HTML (Apache error page)
        if (typeof data === "string" && data.includes("<!DOCTYPE")) {
          return rejectWithValue(
            "Server unavailable — please try again later."
          );
        }

        return rejectWithValue(
          data?.detail || data || "Login failed. Please try again."
        );
      } else if (error.request) {
        return rejectWithValue(
          "Network error — please check your connection or try again later."
        );
      } else {
        return rejectWithValue("An unexpected error occurred during login.");
      }
    }
  }
);


// 🧩 Thunk for restoring user session by token
export const fetchCurrentUser = createAsyncThunk(
  "auth/fetchCurrentUser",
  async (_, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("access_token");
      if (!token) throw new Error("No token in sessionStorage");

      const response = await axios.get(`${API_URL}/users/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      return response.data; // { user, role }
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data?.detail ||
            error.response.data ||
            "Failed to restore user"
        );
      } else if (error.request) {
        return rejectWithValue(
          "Network error — please check your connection or try again later."
        );
      } else {
        return rejectWithValue("Unexpected error restoring session.");
      }
    }
  }
);

const initialState = {
  user: null,
  token: sessionStorage.getItem("access_token") || null,
  isLoggedIn: !!sessionStorage.getItem("access_token"),
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logoutUser: (state) => {
      state.user = null;
      state.token = null;
      state.isLoggedIn = false;
      sessionStorage.removeItem("access_token");
    },
  },
  extraReducers: (builder) => {
    builder
      // 🔹 Login logic
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = {
          ...action.payload.user,
          role: action.payload.role,
        };
        state.token = action.payload.access_token;
        state.isLoggedIn = true;
        sessionStorage.setItem("access_token", action.payload.access_token);
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Login failed";
        state.isLoggedIn = false;
      })
      // 🔹 Restore user session
      .addCase(fetchCurrentUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCurrentUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = {
          ...action.payload.user,
          role: action.payload.role,
        };
        state.isLoggedIn = true;
      })
      .addCase(fetchCurrentUser.rejected, (state, action) => {
        state.loading = false;
        state.user = null;
        state.token = null;
        state.isLoggedIn = false;
        sessionStorage.removeItem("access_token");
        state.error = action.payload || "Failed to restore user";
      });
  },
});

export const { logoutUser } = authSlice.actions;
export default authSlice.reducer;
